export const client = {
  home: "/home",
  services: "/services",
  blog: '/blog',
  servicesDescription: '/services-description',
  appointment: "/appointment",
  learn: "/learn",
  about: "/about",
  contact: "/contact",
  payment: "/payment",
  servicesPayment: "/services-payment",
}